<template>
  <div>
    <navMenu />
    
    <hero :heroTitle="$t('nav.curriculaBtn')" />

    <featured />
    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import featured from "./../components/featured.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "Curricula",
  components: {
    navMenu,
    hero,
    featured,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
